'use strict';

/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/get-proto@1.0.1/~/get-proto/Reflect.getPrototypeOf.js
// module id = 280
// module chunks = 0